import * as types from '../actions/action-types';

const initialState = {
  stories: [],
};

export default (state = initialState, action) => {
  switch (action.type) {

    case types.TOGGLE_FOLIO_NAVIGATION:
      return { ...state, folioNavigationEnabled: !state.folioNavigationEnabled };


    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/reducers/inside.js